<div class="header">
    <h2>Modifica <strong>Ordinativo</strong></h2>
    <div class="breadcrumb-wrapper hidden-xs">
        <ol class="breadcrumb">
            <li><a routerLink="/inspection-general">Gestione Ispezioni</a></li>
            <li><a [routerLink]="'/inspection/' + inspectionOrder.fk_id_inspection">Dettaglio Ispezione</a></li>
            <li><a [routerLink]="'/inspection/order/' + inspectionOrder.id_inspection_order">Dettaglio Ordinativo</a></li>
            <li class="active">Modifica RDC</li>
        </ol>
    </div>
</div>
<div class="row">
    <div class="col-lg-12 portlets">
        <div class="panel">
            <div class="panel-content" style="padding-top: 40px; padding-bottom: 40px;">
                <form (ngSubmit)="onSubmit()" #inspectionDeliveryRequestUpdateForm="ngForm" role="form" class="form-horizontal form-validation">
                    <div class="form-group">
                        <label for="institution_protocol" class="col-sm-3 control-label">Protocollo Ente *</label>
                        <div class="col-sm-6 prepend-icon">
                            <input type="text"
                                   id="institution_protocol"
                                   name="institution_protocol"
                                   class="form-control"
                                   placeholder="Inserisci Protocollo Ente..."
                                   minlength="2"
                                   required
                                   autocomplete="off"
                                   [ngClass]="{
                                        'form-error': !(institution_protocol.valid || institution_protocol.pristine),
                                        'form-success': institution_protocol.valid
                                     }"
                                   [(ngModel)]="inspectionDeliveryRequest.institution_protocol"
                                   #institution_protocol="ngModel">
                            <i class="fa fa-file"></i>
                            <div [hidden]="institution_protocol.valid || institution_protocol.pristine"
                                 class="form-error valid">
                                Inserisci almeno 3 caratteri.
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="code" class="col-sm-3 control-label">Codice</label>
                        <div class="col-sm-6 prepend-icon">
                            <input type="text"
                                   id="code"
                                   name="code"
                                   class="form-control"
                                   placeholder="Inserisci Codice..."
                                   autocomplete="off"
                                   [ngClass]="{
                                        'form-error': !(code.valid || code.pristine),
                                        'form-success': code.valid
                                     }"
                                   [(ngModel)]="inspectionDeliveryRequest.code"
                                   #code="ngModel">
                            <i class="fa fa-barcode"></i>
                        </div>
                    </div>

                    <div class="text-center m-t-20">
                        <button type="submit"
                                class="btn btn-embossed btn-primary"
                                [disabled]="!inspectionDeliveryRequestUpdateForm.form.valid">
                            <i class="icon-pencil"></i> Modifica Richiesta di Consegna</button>
                    </div>

                    <div [hidden]="inspectionDeliveryRequestUpdateResult" class="alert alert-danger">
                        Si è verificato un errore nella modifica della RDC, riprovare.
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
